import * as React from 'react';
import { InfoAnnie } from '../InfoAnnie';
import NewQuoteButton from '../../scenes/CustomerAreaNew/scenes/Components/NewQuoteButton';
import { ICustomerMTAOptions } from '../../scenes/CustomerAreaNew/scenes/MakeAChange';
import { Button } from 'react-bootstrap';
import { windowSize } from '../../hooks/windowSize';
import { IPolicyApplication } from '../../data/api/models';
import { isBefore, isAfter, parse } from 'date-fns';

interface IQuoteAnnieBanner {
  pathName: string;
  customerName?: string;
  customerMTAOptions?: ICustomerMTAOptions
  quoteApplication?: IPolicyApplication
}

export const QuoteAnnieBanner = ({
                                   pathName,
                                   customerName,
                                   customerMTAOptions,
                                   quoteApplication
                                 }: IQuoteAnnieBanner) => {

  const isMobile = windowSize().isMobile;

  const allowedPath = '/account/quotes';
  const allowedDetailsPath = '/account/quotes/';
  const allowedRenewalPath = '/account/renewals/'

  const allowRenewalsBanner = pathName.includes(allowedRenewalPath);
  const allowQuoteListBanner = pathName === allowedPath;
  const allowQuoteDetailsBanner = pathName.includes(allowedDetailsPath);

  const openOpeningHoursReirect = () => {
    window.open('https://www.admiral.com/contact-us/travel', '_blank');
  }

  const handleCallNow = () => {
    if (isMobile) {
      window.open('tel:03332349913', '_self');
    } else {
      window.open('https://www.admiral.com/contact-us/travel', '_blank');
    }
  }

  const isInOpeningHours = () => {
    const fromTime = customerMTAOptions?.other?.opening_hours?.from
    const toTime = customerMTAOptions?.other?.opening_hours?.to

    if (!fromTime || !toTime || fromTime === toTime) {
      return false;
    }

    const beforeTime = parse(fromTime, 'HH:mm', new Date());
    const afterTime = parse(toTime, 'HH:mm', new Date());
    const now = new Date();
    return isAfter(now, beforeTime) && isBefore(now, afterTime);
  }

  const callNowButton = () => {

    if (!isMobile || !isInOpeningHours()) {
      return null;
    }

    return (
      <Button
        bsStyle="danger"
        type="button"
        onClick={handleCallNow}
        className={'medium-width pull-right admiral-red-btn'}
      >CALL NOW</Button>
    )
  }

  if (allowQuoteListBanner) {
    return (
      <div style={{ marginBottom: '20px' }}>
        <InfoAnnie
          title={<span>Looking for a fresh quote click <NewQuoteButton isLink={true} linkText={'here'}/></span>}
          text={'View your stored quotes below'}/>
      </div>
    )
  }

  if (allowQuoteDetailsBanner) {
    return (
      <div style={{ marginBottom: '20px' }}>
        <InfoAnnie
          text={'Before purchasing cover we will ask you to review your quote in full to ensure all the details are correct and the cover meets your needs. You can make changes to your quote and buy once you’re happy with the cover selected.'}/>
      </div>
    )
  }

  if (allowRenewalsBanner) {

    let text;
    let title = 'Hey ' + customerName + '!';
    const isRenewalAuto = quoteApplication?.quoteType === 'renewal' && quoteApplication?.renewalStatus === 'auto'

    if (isInOpeningHours()) {

      if (isRenewalAuto) {
        text = <>Want to discuss your renewal with an agent or have any other questions?<br/>
          Don't hesitate to call us on <b>0333 234 9913</b> - click <span onClick={openOpeningHoursReirect}
                                                                          style={{
                                                                            textDecoration: 'underline',
                                                                            cursor: 'pointer'
                                                                          }}>here</span> for
          our opening hours.</>
      } else {
        text = '';
        title = 'Thank you for insuring with us for the last year ' + customerName + '!'
      }

    } else {
      text = <>Want to discuss your renewal with an agent or have any other questions?<br/>
        Don't hesitate to contact us.
        Click <span onClick={openOpeningHoursReirect}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}>here</span> for our contact details and
        opening hours. </>
    }

    return (
      <div style={{ marginBottom: '20px' }}>
        <InfoAnnie
          title={title}
          text={text}
          renderButton={isRenewalAuto ? callNowButton : null}
        />
      </div>
    )
  }

  return null;

}
